// fslint-disable unitTests
import { piniaPluginPagination, useFibComponents } from '@feeditback/fib-components';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createApp } from 'vue';

import '../node_modules/@feeditback/fib-components/dist/assets/styles/scss/index.scss';
import '../node_modules/@feeditback/fib-components/dist/style.css';

import './assets/styles/scss/mantle.scss';
import App from './App.vue';
import { initialiseSentry } from './helpers/sentry';
import { useRouter } from './router';
import './chartjs';

// Top level awaits aren't available yet, so we have to do this the old-fashioned way :(
(async (): Promise<void> => {
  const rootContainer = '#app';
  const { i18n } = await useFibComponents({
    rootContainer,
    translation: {
      locales: import.meta.glob('./locales/**/*.json'),
      dayjsLocales: import.meta.glob('/node_modules/dayjs/esm/locale/*.js')
    }
  });

  const router = useRouter();

  const app = createApp(App)
    .use(i18n)
    .use(router)
    .use(createPinia().use(piniaPluginPersistedstate).use(piniaPluginPagination));

  initialiseSentry(app, router);

  await router.isReady();

  app.mount(rootContainer);
})();
